import React from 'react';
import { Checkbox, Form } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { FormattedMessage, useIntl } from 'react-intl';

import styles from './styles.module.scss';

const INSTALMENT_BULLET_IDS = [
  'certificates.payment.instalmentBullet.deposit',
  'certificates.payment.instalmentBullet.pending',
] as const;

export function InstalmentDetailsIntro(): React.ReactElement {
  const intl = useIntl();

  return (
    <div className={styles.wrap}>
      <div className={styles.headerRow}>
        <h3 className={styles.title}>
          {intl.formatMessage({ id: 'certificates.payment.instalmentDetailsTitle' })}
        </h3>
        <div className={styles.splitRow}>
          <Form.Item
            name="splitInstalmentDown"
            valuePropName="checked"
            className={styles.checkboxItem}
          >
            <Checkbox className={styles.checkbox}>
              {intl.formatMessage({ id: 'certificates.payment.splitDownPayment' })}
            </Checkbox>
          </Form.Item>
          <FontAwesomeIcon icon={faCircleInfo} className={styles.infoIcon} aria-hidden />
        </div>
      </div>
      <ul className={styles.bullets}>
        {INSTALMENT_BULLET_IDS.map((id) => (
          <li key={id}>
            <FormattedMessage id={id} />
          </li>
        ))}
      </ul>
    </div>
  );
}
